"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16px",
    height: "12px",
    viewBox: "1056 24 16 12"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "preview",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1056.000000, 24.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,2.0085302 C0,0.899249601 0.894513756,0 1.99406028,0 L14.0059397,0 C15.1072288,0 16,0.901950359 16,2.0085302 L16,9.9914698 C16,11.1007504 15.1054862,12 14.0059397,12 L1.99406028,12 C0.892771196,12 0,11.0980496 0,9.9914698 L0,2.0085302 Z M6,8 L6,4 L11,6 L6,8 Z",
    id: "Combined-Shape",
    fill: "#BCBCBC"
  })));
};

exports["default"] = _default;